/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useMemo, useState} from 'react';
import {Entity} from '@ion/core/src/types/entities';
import {SearchCriteria} from '@ion/core/src/types/services';
import {buildMemberSearchCriteria, buildSmartSearchCriteria} from './SearchUtils';
import {SearchFilters} from './types';

interface UseSearchCriteriaProps {
  globalGroupId: number;
  viewSubGroups: boolean;
  entity: Entity;
  filters?: SearchFilters;
  queryString?: string;
  criteriaType?: CriteriaTypes;
}

export enum CriteriaTypes {
  SMART_SEARCH,
  MEMBER_SEARCH
}

/**
 * Re-usable hook that returns a populated search criteria based on the given criteriaType flag
 * for consumption by CTC services.
 */
export const useSearchCriteria = ({
  globalGroupId,
  viewSubGroups,
  entity,
  filters,
  queryString,
  criteriaType = CriteriaTypes.SMART_SEARCH
}: UseSearchCriteriaProps): SearchCriteria => {
  const [searchCriteria, setSearchCriteria] = useState<SearchCriteria>();

  const buildCriteria = criteriaType === CriteriaTypes.SMART_SEARCH
    ? buildSmartSearchCriteria : buildMemberSearchCriteria;

  useMemo(() => {
    setSearchCriteria(buildCriteria({
      accountId : globalGroupId,
      entity,
      viewSubGroups,
      queryString,
      filters
    }));
  }, [globalGroupId, entity, viewSubGroups, filters, queryString]);

  return searchCriteria;
};

export default useSearchCriteria;
